import * as React from 'react';
import autobind from "autobind-decorator";
import { observer } from "mobx-react";

import { DropdownView } from 'src/core/ui/dropdown.view';

interface GenderEditorViewProps {
    label?: string;
	value: 'Neutro' | 'Male' | 'Female';
    onChanged: (number: 'Neutro'|'Male' | 'Female' | null) => void;
    mode: ControlMode;
    required?: boolean;
	onGetErrorMessage?: () => Promise<ValidationError[]>;
}

@observer
export class GenderEditorView extends React.Component<GenderEditorViewProps, any> {
    public constructor(props) {
        super(props);
    }

    public render() {
        let label = this.props.label;
        if (label === undefined) {
            label = 'Gender';
        }
        return (
            <DropdownView label={label}
                onGetErrorMessage={this.props.onGetErrorMessage}
                required={this.props.required}
                model={this.props.value}
                disabled={this.props.mode == 'display'}
                onChanged={(item) => { this.props.onChanged(item != null ? item.value : null) }}
                options={
					[
						{ value: 'Neutro', label: 'Neutro' },
                        { value: 'Male', label: 'Male' },
                        { value: 'Female', label: 'Female' }
                    ]
                }
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/parts/gender-editor.view.tsx